import React from 'react';
import '../../assets/css/case-home.css';
import caseBackgroundIcon from '../../assets/images/case-background-dark.svg';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

export function PrivacyPageHero() {
  const title = useContentToken('privacypagehero.title');

  return (
    <section className="case-aboutpage-hero">
      <div className="case-aboutpage-hero-overlay" role="presentation" aria-hidden="true">
        <img src={caseBackgroundIcon} alt="Case & Associates logo accent background" />
      </div>
      <div className="case-container">
        <nav aria-label="Breadcrumb">
          <ol className="case-breadcrumb">
            <li><a href="/">Home</a></li>
            <li aria-current="page">
              <EditableToken path="privacypagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['privacypagehero.title'].defaultValue} as="span">
                {title}
              </EditableToken>
            </li>
          </ol>
        </nav>
        <EditableToken path="privacypagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['privacypagehero.title'].defaultValue} as="h1">
          {title}
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PrivacyPageHero',
  displayName: 'Privacy Page Hero',
  tokens: {
    'privacypagehero.title': {
      label: 'Page Title',
      type: 'text',
      defaultValue: 'Privacy Policy',
    },
  },
};

(PrivacyPageHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PrivacyPageHero;
